import React from "react";
import dayjs from 'util/dayjs-init.js';
import * as PropTypes from "prop-types";
import DataDuration from "./durationController/dataDuration.jsx";
import { GRAPH_TYPE } from "../../constants/trendGraph/trendGraphType.js";
import { DURATION } from "./calendarDuration/durationOption.js";

export const DurationSelector = React.memo((props) => {
  const {
    vesselId,
    selectedEngine = '',
    selectedGraph,
    currentVessel
  } = props;

  const getDurationType = () => {
    switch (selectedGraph) {
      case GRAPH_TYPE.ENGINE:
        return DURATION.ENGINE;
      case GRAPH_TYPE.ELECTRIC:
        return DURATION.ELECTRIC;
      case GRAPH_TYPE.SEP:
        return DURATION.SEP;
      case GRAPH_TYPE.CUSTOM:
        return DURATION.CUSTOM;
    }
  };

  return (
      <DataDuration
        position={selectedEngine}
        type={getDurationType()}
        vesselId={vesselId}
        minDate={dayjs.utc().subtract(1, "month").format()}
        currentVessel={currentVessel}
      />
  );
});

DurationSelector.propTypes = {
  vesselId: PropTypes.string,
  currentVessel: PropTypes.object,
  selectedEngine: PropTypes.string,
  selectedGraph: PropTypes.string,
};